module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "blcc-book-pages6"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "blcc-book-pages6"
  }, [_c('span', {
    staticClass: "charoverride5"
  }, [_c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages1"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _c('a', {
    staticClass: "calibre8",
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("The Camp: Evening and Night")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Is it true, Captain,” asked Colonel Lavery, “that Pantellaria has been invaded?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Quite true,” said Captain Benucci. He added, without a great deal of conviction, “After heroic resistance our gallant troops, greatly outnumbered, were forced to yield. Many laid down their lives but their deeds live on. Our Duce will not forget them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Quite so,” said Colonel Lavery. “I believe you had something you wished to discuss with me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It arises from the invasion of Pantellaria. That affords me, so to speak, my context for what I wished to say. From now on there may be other assaults—small assaults, you understand—on outlying islands in the Mediterranean. Your troops may even land in Sicily.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“So,” said Colonel Lavery.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Frankly, if they make such an attempt, I do not think that many will survive it. Our German allies are there in great strength. However, there may be temporary successes. All this may serve to inflame the prisoners. They may try to organize something.” He paused for a moment and added, “Something stupid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“We have some very high-spirited officers here,” agreed the Colonel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Captain Benucci seemed suddenly completely serious. He turned his head so that his black eyes looked directly into the Colonel’s washed-out blue ones, and he said, “If any such thing were encouraged, you yourself would incur a terrible responsibility.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yes,” said the Colonel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He looked out of the little window, across the bare, stamped earth of the exercise ground, at the red-brick boundary wall. Without troubling to move his head he could see three platforms, on each of which stood two men. One man controlled a searchlight, the other a machine gun mounted on a tripod. He visualized, for a moment, an unarmed crowd attempting to scale the walls. When he turned back he found that Captain Benucci was still looking at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I demand your full co-operation,” went on the Italian. “Otherwise I shall not answer for the consequences. If any untoward incident were to take place, no one would regret it more than myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“On the whole,” said the Colonel, “I’m inclined to agree with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Silence fell again in the wooden, cabin-like room.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Shrill in the distance sounded the yelps of the Italian soldiers as they herded the last of their obstinate flock into the five big huts. From the Italian quarters a bugle was blowing for evening mess.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("It was the Colonel who broke the silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Is that just a general warning,” he said, “or have you any concrete suggestions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Two suggestions,” said Benucci. “First, I was told—I do not know if it is true—I am naturally not in the confidence of the people concerned—that there might be some attempt to rush the wall. The people who made such an attempt might rely on the fact that the sentries would hesitate to shoot down unarmed men. Such a suggestion is fallacious. They would shoot them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I can assure you that I know of no such plan at the moment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Even if the ordinary soldiers might hesitate to do their duty, I am giving orders that, during the hours of darkness, one of the pair on each sentry platform shall be a member of my own regiment, the Carabinieri. ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("That order will come into effect")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" to-night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Very well,” said the Colonel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Secondly, I must insist that the rule is observed, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("without exception")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(", that no one shall move from hut to hut after evening roll-call when the huts have been closed. After all, it is not a difficult rule to keep. Each hut is self-contained. Each hut has dormitories, latrines, and kitchen. The camp was designed with forethought.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It was indeed,” said the Colonel. During the short period of his captivity, he had been confined, in varying degrees of discomfort, in a museum, a station hotel, a castle, and a monastery. Campo 127 was easily the best camp he had ever seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“There is no reason at all to leave the hut from the time it is locked after evening roll-call, until after breakfast, when morning roll-call has been completed. If a prisoner should be sick, you have your own medical man in each hut. Even if he should die”—Benucci showed his white teeth for a moment under his clipped moustache—“he will keep till morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Oh, quite,” said the Colonel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yet, in spite of this, during the last two months there have been three cases of prisoners being found outside their huts after dark—for trivial reasons, in each case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The Colonel nodded. He knew that a certain amount of “visiting” went on.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“In each case the guards have shot high, as a warning. Those were their orders. The orders have now been changed. They will shoot to kill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yes, I understand,” said the Colonel. As always, with Benucci, he wondered how much of it was truth and how much propaganda. He remembered the last case of “visiting” only a few days previously, and a quite impenitent Roger Byfold saying, “As a matter of fact, I’d just gone over to make up a fourth at bridge in Hut A. One of them spotted me on the way back and the silly bastards spent five minutes shooting all round me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I quite understand,” he repeated. “I’ll give something out. Is that all?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“That is all.” Captain Benucci clicked his heels and walked stiffly out of the room. The Colonel went to the window and watched him, as he strutted away towards the main gate of the camp, a solitary, dapper little figure.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("It was nine o’clock of a perfect summer evening. The sun had disappeared, at last and reluctantly, behind the buttress of the Apennine Mountains which ran up to the west of the camp. It left behind it the deep blue, almost green, light which the sky drew from the hidden Adriatic.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("It was the moment in the day which the Colonel liked best.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The last of the five big huts was locked, and the last of his obstreperous four hundred children was locked away in them. He, a few senior officers, his Adjutant, and half a dozen camp officials, had rooms in the end of the sixth hut, which held the camp offices, the stores, the library, the barber’s shop—dignified names for tiny, partitioned cubicles.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("As a privilege the outer door of this sixth hut was not locked at night. It was, incidentally, a privilege that the Colonel was determined to maintain.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He shuffled the papers on his table into some sort of order, for his bedroom was also his office, and went to look for his Adjutant.")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages8"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Room 10 in Hut C—which was the end room on the south side, next to the kitchen—had a neat label on its door headed “Smokey Joe’s.” Underneath, in the same meticulous handwriting, were six names, in two sets of three:")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Major Grimsdale")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Capt. Baierlein")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Capt. Overstrand")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Capt. Goyles")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Capt. Byfold")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages6"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Lieut. Long")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("It was the only room in the building that had as few as six names on its door and this exclusiveness was due entirely to the forethought of the Italians. Reckoning that if he had six dangerous criminals to watch it was easier, on the whole, to have them together, Captain Benucci had ordered the six to occupy a single room at the end of C Block. It was almost the only order of Captain Benucci they had obeyed with enthusiasm.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("All of them were notorious escapers. All of them had spent long hours undermining Italian property, destroying Italian buildings, cutting up Italian furniture and threatening Italian self-respect and peace of mind. All of them had been, at least once, at large in the Italian countryside, pursuing the will o’ wisp freedom in a variety of unlikely disguises.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Cuckoo” Goyles, Roger Byfold and Tony Long—they worked as a trio, finding the concord which often comes from three discrepant natures—had jumped from a train, and spent fifteen days of unspeakable discomfort in the Apennines before convincing themselves that there was no future in night marching in mountainous country. Alec Overstrand had been out three times, on the last occasion in the company of Martin Grimsdale, when, dressed as Roumanian commercial travellers they had got as far as Bologna before arousing the suspicions of the ever-alert Railway Police. Hugo Baierlein, who was later to prove one of the outstanding escapers of the war, had already made a remarkable four-day journey by goods train from Caserta Hospital to Chiasso on the Swiss frontier. He had actually crossed the frontier and had been shunted back again into Italy, to fall into the hands of the Customs guard.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Although Room 10 had six beds in it, only three of them were occupied. Grimsdale, Baierlein, and Long were all, at that moment, concluding a seven-day spell in the Punishment Block for organized insolence to Captain Benucci.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It may be different in the big world outside these walls,” Roger Byfold was saying, “but in a prisoner-of-war camp, there’s no doubt about it. Crime does pay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Alec Overstrand, who was copying a map on to a small roll of waterproof silk, nodded his agreement. “Cuckoo” Goyles, lying on his bunk absorbed in a phrase book of modern Greek, said nothing. Only the electric light glinted on his steel-rimmed spectacles as he moved his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“In the Union of Soviet Socialist Republics,” went on Byfold, “which a prison camp in many ways resembles, a man’s status and consequence are measured by the amount of living room he is permitted to occupy. Here we are, six of us, none of us of great seniority, yet comfortably lodged in a room designed to hold eight, whilst all around us similar sized rooms are full to overflowing with eight, ten, or even twelve less fortunate prisoners. We enjoy the additional chance—almost, I might say, the certainty—that from time to time our numbers will be even further depleted by the vigilance of Captain Benucci, or the offended dignity of Il Colonello Aletti—”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Do you suppose he’s anything to do with the Hôtel Aletti in Algiers?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Byfold considered the matter. “It’s possible,” he said at last. “He has, now you come to mention it, a certain resemblance to a hôtelier. Not a very high-class hôtelier. The proprietor, possibly, of one of the less well-known eating houses in Soho.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It’s all very well shooting a line about your criminal reputation.” Goyles looked up from his book. “It hasn’t got you a room all to yourself yet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Like Coutoules?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“The little rat.” Overstrand’s rather heavy, red face took on a look of distaste. “Why don’t we string him up and have done with it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Stringing up’s too good,” said Byfold. “I should recommend slow immersion in canteen vermouth—head first, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“He’s not such a bad little beast, really,” said Goyles. “I had quite a long talk with him the other day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“You’re out of this world, Cuckoo. He’s an informer and a stool pigeon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“How do you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Didn’t the caribs go straight to Desmond’s tunnel last week—and hadn’t Tony seen Coutoules snooping round the trap-door only the night before?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Coincidence,” said Goyles. “Desmond’s such an ass. He’s been leaving sand all over his bedroom floor for weeks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Coutoules can’t do much more harm, anyway,” said Byfold. “Not now that he’s tucked away, all by himself, in a little room in the Senior Officers’ Block. And no one ever talks to him now—except Cuckoo here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Schoolboy stuff,” said Goyles calmly. “What’s the use of sending him to Coventry, even if he is a stool-pigeon. If you talk to him you may get something useful out of him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He returned to his studies and silence fell.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Ten minutes later he looked up and said, “Can anyone think of any situation in which it might be useful to know the modern Greek for ‘Please inform me, sir or madam, whether the cabinet of easement is nearer ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("to the cathedral or the railway")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" terminus?’”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages9"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("No one could.")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Other parties were also discussing Cyriakos Coutoules.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Colonel Lavery said to his Adjutant, “I’m worried about Coutoules, Pat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It’s he who should be worrying, sir,” said the Adjutant.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yes, I know. He’s not exactly popular. That’s one of the things I was thinking about.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Are you expecting trouble?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Well—not at the moment. Byfold and that young ass, Overstrand, have both threatened to lynch him. But it’s nothing more than a threat—as yet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“You mean—?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“What do you think would happen if two or three of our hot heads—and we’re not short of hot heads—”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Who’ll get hotter as the war comes closer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Exactly. Well, supposing some of them try to rush the walls. And the guards, instead of being distracted by whatever distraction is offered, are wide awake, and turn a searchlight on them and shoot them down. And suppose someone starts a little story that ‘they had no ")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("chance because Coutoules tipped off the")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" Italians.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“It might be sticky,” agreed the Adjutant. “Tell me, sir, do you really think he’s an informer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I don’t know,” said the Colonel. “It’s so easy to imagine these things. We know nothing about him. He just says he was landed in Sicily to do sabotage. He’s got Greek Army papers, only no one here knows enough about the Greek Army to say whether they’re genuine or not. We can’t check up on his home background—regiment and school and so on—as we could if he was a British officer. That makes him automatically subject to suspicion.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“One couldn’t condemn him on that sort of thing alone,” said the Adjutant. “But Desmond Foster’s tunnel—that was a bit too coincidental to be nice.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I wasn’t too happy about that,” agreed the Colonel. “But tunnels get found in hundreds of ways. The Italians may have known about it for weeks and just chosen that moment to pounce. If that had been all there was against him, I shouldn’t have worried.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Has something else happened, sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yes. Something I haven’t quite worked out yet. Coutoules came to me this afternoon and practically begged me to put him back in one of the main huts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“He ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Yes, I know. It didn’t seem quite natural to me. After all, he’s got a room to himself in our hut here. Almost anyone in the camp would give a year’s pay for a private room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Besides,” said the Adjutant, “he must know he’s not popular. So why does he want to go and put himself back into the lion’s den?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Exactly. There’s no doubt he did want to, though. No doubt at all. I’ve never seen anyone more anxious in my life. Practically went down on his knees.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Did he say why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Not really—just a lot of talk. He didn’t like being alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Do you think he was play-acting?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages9"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I didn’t get that impression,” said the Colonel. “If you want my real opinion, I think he was scared stiff.”")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The Punishment Block lay in the north-west corner of the camp, alongside the Carabinieri Office. With the Camp Guard Quarters and other Italian administrative huts, it lay outside the inner line of defences that guarded the camp proper. This was one of its advantages, and it was not entirely by chance that three such hardened escapers as Tony Long, Hugo Baierlein, and “Hefty” Grimsdale should have been guilty of the simultaneous offences which had landed them into the cooler together.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("As nine o’clock struck Tony Long was standing on his bed looking out of the single barred window of his cell. He was reflecting, in a detached way, on the problem of escape from a prison camp. Camp 127 was not an easy place to escape from. It had been designed, as Captain Benucci had pointed out to Colonel Lavery, with a good deal of forethought. Miracles apart, there only were three ways of getting out of any camp. You could tunnel under the walls, you could climb over the walls, or you could walk out of the gate.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("All these methods had their own drawbacks. The real disadvantage of tunnelling was the length of time it involved. What with the constant watchfulness of the Italians, their security checks and their sudden searches, any tunnel was almost certain to be spotted in the end. To suppose that you could keep it entirely hidden for the six or eight months necessary to reach the open was like gambling on the same number coming up six or eight times running at the roulette table. It could happen, but it didn’t very often.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("To get over the walls was a proposition of much greater risk but carrying with it that fundamental chance of success which must attend any bold and unexpected manœuvre. Three months before, a particularly well-organized effort of this sort had been completely successful. The camp lights had been fused and, in the few seconds that the darkness had lasted, four officers armed with hooked ladders had crossed the wall midway between sentry and sentry, and had disappeared. (It is true that all of them had eventually been recaptured and were now in the fortress prison of Gavi for their pains.)")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Lastly there was the gate. To crash the gate was a project which needed expert disguise, nerve, and plenty of luck. At 127 you needed a double portion of luck, for there were, in fact, two gates, an inner gate and an outer gate, and a very elaborate security system of passes and checks existed between the two, which no one had yet entirely succeeded in defeating.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Standing at his window, that evening, Tony watched the system at work. A small open laundry van came across the prisoners’ compound and approached the inner gate. Despite the fact that it was driven by one carabinier and had another seated on the back, the sentry abated nothing of his caution. He checked both passes and then went round and thrust his long needle bayonet through one or two of the larger bundles. The carib in the back said something and the driver laughed. The sentry walked across to the telephone, and spoke to the Guard House. Not till he had had a reply would he even open the inner gate. At the outer gate, although it was in full view of the inner one, and not more than thirty yards away, the whole performance was repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Tony sighed, shifted his weight on to his other foot, and wondered how long it would be before it was dark. He had blond hair and a Nordic, rather serious face, which looked deceptively youthful. Only his mouth and chin had the hard lines of a generation which had been brought up to war.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("By half-past ten most of the light was out of the sky, but it was eleven o’clock before he moved.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The first thing he did was to take out a short piece of wire which appeared to form part of his bed and thrust it through the ventilation between his cell and the next. He jerked it once or twice and then pulled it out, and put his ear to the ventilator.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He could hear Baierlein’s voice quite distinctly.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Not yet. The outer gate guard is on the other side, looking this way. I’ll knock when he changes over.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Ten minutes later a quiet knock sounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Tony put his hand up and appeared to be fumbling with one of the bricks which formed the sill of the window. Then he put his other hand up, and twisted one of the bars. Then bar and brick came clean out of the window. The whole operation took less than thirty seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The gap left by the removal of the bar was not much more than twelve inches, but it was enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Tony climbed from the bed on to the sill, put a long arm through, caught the gutter above the window, and pulled.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("A minute later he was on the roof of the Punishment Block, hidden in the deep shadow behind a buttress.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Baierlein, in Cell 2, turned to Grimsdale with a smile and said: “He’s up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Should be all right now,” said Grimsdale. “They won’t see him so long as he keeps still.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“They certainly won’t hear him,” said Baierlein. “Not with that filthy row going on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("In the Carabinieri Office next door a loud-speaker, full on, was relaying a dance band from Radio Romã.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The two men lay in silence in the dark cell. Each was deep in his own thoughts. There was an occasional rustle as Baierlein turned on his bed to look at the illuminated face of his watch.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages9"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Outside, the saxophones laughed and sobbed and the high trumpets screamed.")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Three hearts gives us game, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Pass,” said Billy Moxhay.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Four hearts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Three hearts,” said Tag Burchnall.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Oh, so it does. Sorry, I’m sure,” said Rollo Betts-Hanger. “Pass then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Pass,” said Gerry Parsons. “Good fun this afternoon, wasn’t it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“First class,” said Rollo. “I thought we were a bit weak in the scrum.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Definitely weak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“We want a bit more weight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“A lot more weight. Aubrey and Peter don’t push their weight at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“We really need a first-class man behind them. Someone who can lock the back row.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“What about—oh, sorry. I didn’t know you were waiting for me. I thought you were pondering. I’m playing the queen. I was going to say, what about Grimsdale? He’s a Hirburnian, isn’t he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I tried him—of course. He won’t do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Won’t play rugger?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“That’s what he told me. He said he’d always been made to play at school and in the army. In a prisoner-of-war camp he was going to please himself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Must have been pulling your leg. Why, he played for Middlesex, didn’t he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“The truth of the matter is,” said Rollo, “that he spends so much time over this escaping stuff that he hasn’t got time for anything else.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Of course, in theory, I’m all for escaping,” said Gerry Parsons. “It’s one’s duty, and so forth. But the fact of the matter is—oh, it’s me again, is it?—the fact of the matter is that no one ever really gets anywhere. It isn’t as if there was any chance even of getting out of this camp—to say nothing of getting out of the country—and when anyone does try, what happens—?”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“They cut off the showers,” said Tag Burchnall. “You can’t trump that, Billy. Hearts ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _c('span', {
    staticClass: "charoverride6"
  }, [_vm._v(" trumps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“That’s what I mean. They make everyone uncomfortable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Still,” said Tag, “one doesn’t exactly want to stand in their way. One wouldn’t want to do a Coutoules,” he added.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I can’t think why someone hasn’t taken the little beast right apart,” said Billy Moxhay. “I should have thought the S.B.O. ought to take it up. All that’s happened to the little blot is that he’s got a room of his own. I’m trumping that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“You can’t trump with that card,” said Tag. “I know it looks like the knave of hearts but it isn’t really. It’s been crossed out. It’s the three of clubs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“I thought the other knave of hearts was the three of clubs.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“No, that is the knave of hearts. It’s turned down in one corner. That makes ten tricks. Game with one overtrick. Eight hundred on the rubber.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Scores were carefully checked and eight small figs were pushed across the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages9"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("The president of the Old Hirburnian Rugby Football Club cut, and the cards were dealt again.")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("At two o’clock Hugo Baierlein turned over on his bunk and sat up. He had many of the talents of the true escaper. One was the ability to sleep anywhere and wake on demand.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He got out of bed, picked up a chair, put it on the table which was under the high, barred window and climbed on to it. He manœuvred the bars in much the same way that Tony Long had done in his cell and after a few minutes he also had the middle one loose. He then put his arm and shoulder out, reached up and scratched very gently on the iron gutter.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He waited, and scratched again, until he heard the muffled sounds which indicated that Tony Long was on his way down. He gave him a few minutes and then crossed to the ventilator.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He heard Tony’s voice, still puffed from his descent.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Went very well. The chap on the corner turned his searchlight at me twice. He couldn’t see me, of course; I was behind the parapet. Don’t think he was suspicious. Just jumpy. I think I’ve spotted how the gate sentry works, too. He spends most of his time in the box with his back to us, but he comes out every half-hour, just before the Sergeant arrives on his rounds. I’ve written down the time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“Good,” said Baierlein. “I’ll make a note of that myself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("“You’ll have to be damned quiet getting up,” said Tony. “You haven’t got a ruddy great dance band to cover you like I had. I’ll give you the word when to start.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Five minutes later Baierlein was on the roof.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("It was cold enough to make him feel glad of his double layer of underclothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He was lying alongside the low parapet which divided the flat roof. His wrist-watch was strapped with its luminous face on the inside of his left wrist. In his right hand he had a tiny black notebook and pencil. His job was to note down every movement of the sentry on the main gate and of the pair on the north-west guard platform.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He faced the prospect of approximately two and a half hours of immobility.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Under the full Italian moon, which paled even the arc-lamps round the perimeter, the camp lay black and sharp. Every few minutes a searchlight from one of the guard platforms blinked its frosty carbon-blue eye and swept across the enclosure.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Baierlein lay safely in the long black shadow of the parapet. His eyes were on the gate sentry. He saw exactly what Tony had meant. The chap was too slack to stand his post properly. He preferred to lounge in the comparative comfort of the box. Only, every half-hour, just before the Sergeant of the Guard announced to the world the start of his rounds by throwing open the guard-room door, the sentry left the box, crossed the gateway, and stood facing the Punishment Block.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("In that position alone was he a danger.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages9"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Baierlein glanced at the watch face, and made a meticulous note in his book. It was for moments like this that he lived—and was nearly to die, once or twice, before he finally hobbled across the Swiss frontier at Gottmadingen eighteen months later.")])]), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages7"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages2"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("On the guard platform at the north-east corner Ordinary Soldier Biancelli stamped his feet and prayed for his relief. He hated guard duty at the best of times but he hated it still more now that, in place of his friend, Moderno, he had this unspeakable, unsociable, Marzotto beside him. His dislike was not personal. It was the dislike of a member of an ordinary corps for the member of a privileged corps. He, Biancelli, was a soldier. A soldier of the king. Marzotto, although he styled himself “of the Regiment of Carabinieri Reali,” was a policeman. He took his orders from Captain Benucci, who took them from some Colonel of Carabinieri at District Headquarters, who took them, in the long run, from Il Duce.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Biancelli was distressed both by his discomforts and his responsibilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("In the old days it had been simple. If you saw an English prisoner escaping you shot at him. Now things were more complicated.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He looked sideways at Marzotto, who avoided his gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("As an ordinary soldier he was not told much about how the war was going, or what was happening in the camp he was guarding. But he could not help being aware of certain undercurrents of feeling, certain possibilities.")])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("He stamped his feet again and watched the sky lightening imperceptibly towards morning.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61583293","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Chapter_1.vue
// module id = 78
// module chunks = 0